import { create } from 'zustand';

/**
 * Shared backward-navigation confirm dialog state (StepHeader + StepFooter).
 * @typedef {{ targetStep: string, message: string }} PendingBackwardNav
 */
const useBackwardNavigationStore = create((set) => ({
  /** @type {PendingBackwardNav | null} */
  pending: null,
  setPending: (pending) => set({ pending }),
  clearPending: () => set({ pending: null }),
}));

export default useBackwardNavigationStore;
